import { Box, SimpleGrid, Skeleton } from "@chakra-ui/react";
import { AvatarConfig } from "common";
import { Avatar } from "./Avatar";
import { MdDoNotDisturb } from "react-icons/md";

interface AvatarEditorPartSelectionProps<T> {
  part: T;
  setPart: (part: T) => void;
  options: T[];
  toAvatarConfig: (part: T) => AvatarConfig;
  isLoading: boolean;
}

export function AvatarEditorPartSelection<T>({
  part,
  setPart,
  options,
  toAvatarConfig,
  isLoading,
}: AvatarEditorPartSelectionProps<T>) {
  return (
    <SimpleGrid
      minChildWidth={"100px"}
      spacing={2}
      maxHeight={"40vh"}
      overflowY={"auto"}
      padding={2}
    >
      {options.map((option) =>
        option !== null ? (
          <Box
            key={`${option}`}
            onClick={() => setPart(option)}
            boxShadow={part === option ? "outline" : undefined}
            borderRadius={8}
            overflow={"hidden"}
          >
            {!isLoading ? (
              <Avatar config={toAvatarConfig(option)} />
            ) : (
              <Skeleton height={"100px"} />
            )}
          </Box>
        ) : (
          <Box
            key={`empty`}
            onClick={() => setPart(option)}
            boxShadow={part === option ? "outline" : undefined}
            display={"flex"}
            alignItems={"center"}
            justifyContent={"center"}
            borderRadius={8}
            overflow={"hidden"}
          >
            {!isLoading ? <MdDoNotDisturb size={50} /> : <Skeleton />}
          </Box>
        )
      )}
    </SimpleGrid>
  );
}
